<template>
  <default-layout>
    <div class="container-fluid">
      <div id="about" class="flex text-white gap-4 w-full h-auto p-5 bg-blue-800 justify-center">
        <div class="flex flex-col w-5/8 gap-4 text-left">
          <p class="text-2xl xl:text-4xl 3xl:text-6xl font-medium title-font xl:mb-0 text-center py-6">TransMAP Data Hub</p>
          <p class="font-light text-base lg:text-lg xl:text-xl 3xl:text-2xl text-left">
            Conducted through the Maritime Transportation Research and Education Center (MarTREC), the Transportation and Maritime Analytics
            Partnerships Hub (TransMAP) project is supported by the Maritime Administration of the U.S. Department of Transportation. The
            team, led by the University of Arkansas in partnership with the Texas A&M Transportation Institute, is working to make available
            large-scale data and visualization tools related to maritime freight transportation on infrastructure, systems, and networks
            accessible to humans and machines through the Internet of things, in order to enable improved resilience, planning, investment
            and operational decisions.
          </p>
          <a
            href="https://castuofa.github.io/transmap/quickstart/"
            target="_blank"
            type="button"
            class="flex bg-white p-1 px-2 rounded text-gray-700 text-xl justify-center self-center font-bold"
          >
            Quick Start Guide
          </a>
        </div>
      </div>
      <resource-type-summary />
      <search-bar />
      <python-api-section />
      <resource-category-summary />
    </div>
  </default-layout>
</template>
<script>
import ResourceTypeSummary from '@/components/home-components/ResourceTypeSummary'
import ResourceCategorySummary from '@/components/home-components/ResourceCategorySummary'
import SearchBar from '@/components/home-components/SearchBar'
import PythonApiSection from '@/components/home-components/PythonApiSection'
import { useStore } from 'vuex'
import DefaultLayout from '@/layouts/Default'

export default {
  components: { DefaultLayout, SearchBar, ResourceCategorySummary, ResourceTypeSummary, PythonApiSection },
}
</script>
